import { BaseModel } from '../../_base/crud';

export class DocumentLibrary extends BaseModel {
  id: number;
  body: string;
  file: any[];
  tags: any[];
  receiver: any[];
  // tslint:disable-next-line:variable-name
  sender_email: string;
  data: any;
  // tslint:disable-next-line:variable-name
  is_completed: boolean;
  // tslint:disable-next-line:variable-name
  sender_name: string;

  clear() {
    // Intentional no-op: Method will be implemented by subclasses
  }
}
